export enum ResponseStatus {
    Loading = 'Loading',
    Success = 'Success',
    Error = 'Error',
    NoData = 'No data',
}
